export default "__VITE_ASSET__8fc6dedd__"